// extracted by mini-css-extract-plugin
module.exports = {"social-row":"social-row__2QJW5","social-btn__wrap":"social-btn__wrap__1NXLU","social-btn":"social-btn__1njs7","twitter-btn":"twitter-btn__2VQZ5","fb-btn":"fb-btn__20rHB"};